import { IHinhThucGiang } from "../../../model/respone/category/IHinhThucGiang";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHinhThucGiangActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IHinhThucGiang[],
    LOAD_ERROR: "",
};

export const eHinhThucGiangActionIds = generateActionTypeIds(eHinhThucGiangActionsObj, "HINH_THUC_GIANG");
export type IHinhThucGiangActionTypes = IGenericActionType<typeof eHinhThucGiangActionsObj, "HINH_THUC_GIANG">;